import React, { useState } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';
import './OfferModal.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const OfferModal = ({ artwork, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    amount: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/offers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          artwork_id: String(artwork.id),
          artwork_title: artwork.title,
          name: formData.name,
          email: formData.email,
          amount: parseFloat(formData.amount),
          message: formData.message
        }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.detail || 'Failed to submit offer');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="offer-overlay" onClick={onClose}>
      <div className="offer-modal" onClick={(e) => e.stopPropagation()}>
        <button className="offer-close" onClick={onClose} data-testid="offer-close">
          <X size={20} />
        </button>

        {submitted ? (
          <div className="offer-success">
            <h2>Offer received</h2>
            <p>Thank you for your interest in <em>{artwork.title}</em>.</p>
            <p>C. Llaguno will review your offer and respond by email within a few days.</p>
            <Button onClick={onClose} className="offer-done-btn">
              Close
            </Button>
          </div>
        ) : (
          <>
            <h2>Make an Offer</h2>
            <p className="offer-artwork-info">
              <span>{artwork.title}</span>
              <span className="offer-listed-price">
                Listed at ${Number(artwork.price).toLocaleString('en-US', { minimumFractionDigits: 2 })}
              </span>
            </p>

            <form onSubmit={handleSubmit} className="offer-form">
              <div className="offer-field">
                <label>Your name *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  data-testid="offer-name"
                />
              </div>

              <div className="offer-field">
                <label>Email *</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  data-testid="offer-email"
                />
              </div>

              <div className="offer-field">
                <label>Your offer (USD) *</label>
                <input
                  type="number"
                  required
                  min="1"
                  step="0.01"
                  placeholder="0.00"
                  value={formData.amount}
                  onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                  data-testid="offer-amount"
                />
              </div>

              <div className="offer-field">
                <label>Message (optional)</label>
                <textarea
                  rows="3"
                  placeholder="Tell us anything you'd like the artist to know..."
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  data-testid="offer-message"
                />
              </div>

              {error && <p className="offer-error">{error}</p>}

              <div className="offer-buttons">
                <button type="button" onClick={onClose} className="offer-cancel">
                  Cancel
                </button>
                <button type="submit" disabled={submitting} className="offer-submit" data-testid="offer-submit">
                  {submitting ? 'Sending...' : 'Submit Offer'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default OfferModal;
